import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/** @jsx jsx */
import { jsx } from '@emotion/core';
import { defaultAttributesFn } from '../utils';

var disabledBorder = function disabledBorder(iconTokens) {
  return {
    stroke: iconTokens.borderColor.disabled,
    strokeWidth: iconTokens.borderWidth
  };
};

var activeBorder = function activeBorder(iconTokens) {
  return {
    stroke: iconTokens.borderColor.active,
    strokeWidth: iconTokens.borderWidth
  };
};

var hoveredAndCheckedBorder = function hoveredAndCheckedBorder(iconTokens) {
  return {
    stroke: iconTokens.borderColor.hoveredAndChecked,
    strokeWidth: iconTokens.borderWidth
  };
};

var hoveredBorder = function hoveredBorder(iconTokens) {
  return {
    stroke: iconTokens.borderColor.hovered,
    strokeWidth: iconTokens.borderWidth
  };
};

var checkedBorder = function checkedBorder(iconTokens) {
  return {
    stroke: iconTokens.borderColor.checked,
    strokeWidth: iconTokens.borderWidth
  };
};

var focusedBorder = function focusedBorder(iconTokens) {
  return {
    stroke: iconTokens.borderColor.focused,
    strokeWidth: iconTokens.borderWidth
  };
};

var invalidBorder = function invalidBorder(iconTokens) {
  return {
    stroke: iconTokens.borderColor.invalid,
    strokeWidth: iconTokens.borderWidth
  };
};

var invalidAndCheckedBorder = function invalidAndCheckedBorder(iconTokens) {
  return {
    stroke: iconTokens.borderColor.invalidAndChecked,
    strokeWidth: iconTokens.borderWidth
  };
};

var getBorderColor = function getBorderColor(_ref) {
  var tokens = _ref.tokens,
      props = _objectWithoutProperties(_ref, ["tokens"]);

  // Being disabled removes borders in all states
  if (props.isDisabled) {
    return disabledBorder(tokens.icon);
  } // Being takes precedence


  if (props.isActive) {
    return activeBorder(tokens.icon);
  } // Then being focused


  if (props.isFocused) {
    return focusedBorder(tokens.icon);
  } // Then being invalid


  if (props.isInvalid) {
    if (props.isChecked) {
      return invalidAndCheckedBorder(tokens.icon);
    }

    return invalidBorder(tokens.icon);
  } // Then hoverstates


  if (props.isHovered) {
    if (props.isChecked) {
      return hoveredAndCheckedBorder(tokens.icon);
    }

    return hoveredBorder(tokens.icon);
  }

  if (props.isChecked) {
    return checkedBorder(tokens.icon);
  }

  return {
    stroke: tokens.icon.borderColor.rest,
    strokeWidth: tokens.icon.borderWidth
  };
};

var getTickColor = function getTickColor(props) {
  var isChecked = props.isChecked,
      isDisabled = props.isDisabled,
      isActive = props.isActive,
      icon = props.tokens.icon;
  var color = icon.tickColor.checked;

  if (isDisabled && isChecked) {
    color = icon.tickColor.disabledAndChecked;
  } else if (isActive && isChecked && !isDisabled) {
    color = icon.tickColor.activeAndChecked;
  } else if (!isChecked) {
    color = icon.tickColor.rest;
  }

  return color;
};

var getBoxColor = function getBoxColor(props) {
  var isChecked = props.isChecked,
      isDisabled = props.isDisabled,
      isActive = props.isActive,
      isHovered = props.isHovered,
      icon = props.tokens.icon; // set the default

  var color = icon.boxColor.rest;

  if (isDisabled) {
    color = icon.boxColor.disabled;
  } else if (isActive) {
    color = icon.boxColor.active;
  } else if (isHovered && isChecked) {
    color = icon.boxColor.hoveredAndChecked;
  } else if (isHovered) {
    color = icon.boxColor.hovered;
  } else if (isChecked) {
    color = icon.boxColor.checked;
  }

  return color;
};

export var iconWrapperCSS = function iconWrapperCSS(props) {
  return {
    lineHeight: 0,
    flexShrink: 0,
    color: getBoxColor(props),
    fill: getTickColor(props),
    transition: 'all 0.2s ease-in-out;',

    /* This is adding a property to the inner svg, to add a border to the checkbox */
    '& rect:first-of-type': _objectSpread({
      transition: 'stroke 0.2s ease-in-out;'
    }, getBorderColor(props)),

    /**
     * Need to set the Icon component wrapper to flex to avoid a scrollbar bug which
     * happens when checkboxes are flex items in a parent with overflow.
     * See AK-6321 for more details.
     **/
    '> span': {
      display: 'flex'
    }
  };
};
export function IconWrapper(_ref2) {
  var attributesFn = _ref2.attributesFn,
      cssFn = _ref2.cssFn,
      children = _ref2.children,
      props = _objectWithoutProperties(_ref2, ["attributesFn", "cssFn", "children"]);

  return jsx("span", _extends({
    css: cssFn(props)
  }, attributesFn(props), {
    children: children
  }));
}
export default {
  component: IconWrapper,
  cssFn: iconWrapperCSS,
  attributesFn: defaultAttributesFn
};